import React from "react";
import { Modal, Input, Table, Popover, Button, DatePicker,  Upload, Icon,} from "antd";
import {AddUpdateHotSheetForm} from "../../tracks/hotsheet/popups/AddUpdateHotSheet";
import {Images} from "../../../controller/Images";

const {RangePicker} = DatePicker;
const Search = Input.Search;

export class Attachments extends React.Component {

  render() {
    const { visible } = this.props;

    return (
      <Modal closable={false} centered visible={visible} onOk={() => this.props.onCancel()}
             onCancel={() => this.props.onCancel()} width='75%' className="view-data-modal view-hotsheet-mdl">
        <div className="row m-0">
          <div className="col-sm-6 col-12 view-modal-header">
            <h3><span>Project Log</span></h3>
          </div>
          <div className="col-sm-6 col-12 view-modal-header">
               <Upload>
                <a href="#">
                  <Icon type="upload" /> Click to Upload
                </a>
              </Upload>
          </div>
        </div>
        <div className="fileAttachment-main">
          <div className="row m-0 w-100">
            <h6 className="text-uppercase  w-100">Folders</h6>
          </div>
          <div className="row m-0 w-100 ab-folderDetails align-items-center">
            <div className="ab-folders">
              <img className="img-fluid" src={Images.folder_icon} alt="folder icon"/>
              <h5 className="text-uppercase">Ab Tracks</h5>
            </div>
            <div className="ab-folders">
              <img className="img-fluid" src={Images.folder_icon} alt="folder icon"/>
              <h5 className="text-uppercase">Ab Accounts</h5>
            </div>
            <div className="ab-folders">
              <img className="img-fluid" src={Images.folder_icon} alt="folder icon"/>
              <h5 className="text-uppercase">Ab Tracks</h5>
            </div>
            <div className="ab-folders ab-buttons">
              <button className="add-plusBtn">
                <i className="fa fa-plus" />
              </button>
            </div>
          </div>
          <div className="row m-0 w-100">
            <h6 className="text-uppercase  w-100">Files</h6>
          </div>
          <div className="row m-0 w-100 ab-folderDetails align-items-center">
            <div className="ab-foldersTxt">
              <div className="w-100 fileUpload">
                <img className="img-fluid" src={Images.file_icon_large} alt="file icon"/>
              </div>
              <div className="w-100 fileTxtDetails">
                <img className="img-fluid" src={Images.file_icon} alt="folder icon"/>
                <h5 className="text-uppercase">Ab Tracks.Txt</h5>
              </div>
            </div>
            <div className="ab-foldersTxt">
              <div className="w-100 fileUpload">
                <img className="img-fluid" src={Images.file_icon_large} alt="file icon"/>
              </div>
              <div className="w-100 fileTxtDetails">
                <img className="img-fluid" src={Images.file_icon} alt="folder icon"/>
                <h5 className="text-uppercase">Ab Tracks.Txt</h5>
              </div>
            </div>
            <div className="ab-foldersTxt">
              <div className="w-100 fileUpload">
                <img className="img-fluid" src={Images.file_icon_large} alt="file icon"/>
              </div>
              <div className="w-100 fileTxtDetails">
                <img className="img-fluid" src={Images.file_icon} alt="folder icon"/>
                <h5 className="text-uppercase">Ab Tracks.Txt</h5>
              </div>
            </div>
            <div className="ab-foldersTxt">
              <div className="w-100 fileUpload">
                <img className="img-fluid" src={Images.file_icon_large} alt="file icon"/>
              </div>
              <div className="w-100 fileTxtDetails">
                <img className="img-fluid" src={Images.file_icon} alt="folder icon"/>
                <h5 className="text-uppercase">Ab Tracks.Txt</h5>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/popups/Attachments.jsx